import { graphql, useStaticQuery } from "gatsby";
import * as React from "react"; // tslint:disable-line
import { ReflectionsProvider as Provider } from "../../components/context/reflections-context";
import { platformProviderValue } from "@shapeable/ui";

const REFLECTIONS_QUERY = graphql`
query PlatformAllReflectionsQuery {
  platform { allReflections {
    __typename
    taxonomyLabel
    _schema {
      label
      pluralLabel
    }
    id
    path
    slug
    name
    published
    typeLabel
    authors {
      
        
      
          id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
      
        
        
              openGraph { 
                id title 
                
                image { 
                  id url url2x 
                  thumbnails { 
                    id bubbleMedium { id url url2x }
                  }
                  
                } 
              }
            
      
    }
    challenges {
      openGraph { image { url } }
      _schema { label pluralLabel }
      __typename id name slug
    }
    openGraph {
      description {
        text
      }
      image {
        url
        url2x
        thumbnails {
          card {
            url
            url2x
          }
          bubble {
            url
            url2x
          }
        }
      }
    }
    color {
      id
      name
      value
    }
  } }
}

`

export const ReflectionsProvider: React.FC<any> = ({ children }) => {
  return (
    <Provider value={ platformProviderValue( useStaticQuery(REFLECTIONS_QUERY), 'allReflections' ) }>{children}</Provider>
  )
}